import TabsLayout from '~/client/components/TabsLayout'

export const routeOptions = {
  mustBeUser: true
}

export default function Layout(){
  return <TabsLayout
    maxWidth="md"
    tabs={[
      {
        label: 'Profile',
        path: '/settings/',
      },
      {
        label: 'Password',
        path: '/settings/password',
      },
      {
        label: 'Apps',
        path: '/settings/apps',
      },
      {
        label: 'Sessions',
        path: '/settings/sessions',
      },
      {
        label: 'OAuth',
        path: '/settings/oauth',
      },
    ]}
  />
}
